var map = {
	"./blue/Ashi-guruma.mp4": 6639,
	"./blue/Hane-goshi.mp4": 4135,
	"./blue/Kata-gatame.mp4": 2537,
	"./blue/O-guruma.mp4": 8111,
	"./blue/Soto-makikomi.mp4": 5992,
	"./blue/Sumi-gaeshi.mp4": 3374,
	"./blue/Tsubame-geashi.mp4": 3185,
	"./blue/Uchi-mata(hip).mp4": 3325,
	"./blue/Uki-gatame.mp4": 2995,
	"./blue/Uki-waza.mp4": 9427,
	"./blue/Ura-nage.mp4": 242,
	"./blue/Ushiro-goshi.mp4": 2409,
	"./blue/Yoko-gake.mp4": 4307,
	"./blue/Yoko-guruma.mp4": 2546,
	"./blue/Yoko-otoshi.mp4": 8557,
	"./brown/Kata-guruma.mp4": 5569,
	"./brown/O-soto-guruma.mp4": 6891,
	"./brown/Sumi-otoshi.mp4": 5073,
	"./brown/Uki-otoshi.mp4": 6694,
	"./brown/Utsuri-goshi.mp4": 2021,
	"./brown/Yoko-wakare.mp4": 3636,
	"./green/Harai-tsuri-komi-ashi.mp4": 6469,
	"./green/Okuri-ashi-harai(barai).mp4": 6795,
	"./green/Sasae-tsuri-komi-ashi.mp4": 5703,
	"./green/Seoi-otoshi.mp4": 7918,
	"./green/Sode-tsuri-komi-goshi.mp4": 390,
	"./green/Tani-otoshi.mp4": 6184,
	"./green/Tomoe-nage.mp4": 2395,
	"./green/Uki-goshi.mp4": 707,
	"./green/Yoko-sumi-gaeshi.mp4": 3982,
	"./green/Yoko-tomoe-nage.mp4": 344,
	"./green/tsurikomigoshi.mp4": 4188,
	"./orange/De-ashi-harai.mp4": 1929,
	"./orange/Harai-goshi.mp4": 2386,
	"./orange/Ippon-seoi-nage.mp4": 9261,
	"./orange/Ko-soto-gake.mp4": 1791,
	"./orange/Kubi-nage.mp4": 5801,
	"./orange/Morote-seoi-nage.mp4": 4969,
	"./orange/O-soto-gari.mp4": 9987,
	"./orange/Tai-otoshi.mp4": 8749,
	"./orange/Tsuri-goshi.mp4": 8790,
	"./orange/Tsuri-komi-goshi.mp4": 8783,
	"./orange/Uchi-mata.mp4": 2923,
	"./yellow/Eri-seoi-nage.mp4": 4699,
	"./yellow/Hiza-guruma.mp4": 7986,
	"./yellow/Kami-shiho-gatame.mp4": 7014,
	"./yellow/Ko-soto-gari.mp4": 7842,
	"./yellow/Ko-uchi-gari.mp4": 7682,
	"./yellow/Koshi-guruma.mp4": 1266,
	"./yellow/Kuzure-kesa-gatame.mp4": 587,
	"./yellow/O-goshi.mp4": 2100,
	"./yellow/O-soto-otoshi.mp4": 6016,
	"./yellow/O-uchi-gari.mp4": 6593,
	"./yellow/Tate-shiho-gatame.mp4": 1724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5960;